import { Button } from '../../shared/ui/button';
import { CopyIcon } from '../../shared/ui/icons';
import { useCopy } from '../../shared/lib/use-copy';
import type { IDnsInstruction } from '../../entities/custom-domain';

const Row = ({ type, name, value }: { type: string; name: string; value: string }) => {
  const { copied, copy } = useCopy();
  return (
    <tr className="border-t border-border-row">
      <td className="py-2 pr-4 font-mono text-data text-primary">{type}</td>
      <td className="py-2 pr-4 font-mono text-data text-primary">{name}</td>
      <td className="py-2 pr-4 font-mono text-data text-primary">{value}</td>
      <td className="py-2 text-right">
        <Button variant="secondary" size="sm" onClick={() => void copy(value)}>
          <CopyIcon size={12} /> {copied ? 'Copied' : 'Copy'}
        </Button>
      </td>
    </tr>
  );
};

export const DnsRecords = ({ record }: { record: IDnsInstruction }) => (
  <table className="mt-3 w-full">
    <thead>
      <tr className="text-left text-meta text-faint">
        <th className="pb-2 font-normal">Type</th>
        <th className="pb-2 font-normal">Name</th>
        <th className="pb-2 font-normal">Value</th>
        <th />
      </tr>
    </thead>
    <tbody>
      {record.values.map((value) => (
        <Row key={value} type={record.type} name={record.name} value={value} />
      ))}
    </tbody>
  </table>
);

export const FoundRecords = ({
  name,
  found,
  proxied,
}: {
  name: string;
  found: { type: string; value: string }[];
  proxied?: boolean;
}) => (
  <div className="mt-3">
    <p className="border-b border-border-row pb-2 text-meta text-faint">What we found</p>
    {found.map((record) => (
      <p key={`${record.type}${record.value}`} className="py-2 font-mono text-data text-primary">
        {record.type}&nbsp;&nbsp; {name}&nbsp;&nbsp; {record.value}
        {proxied && <span className="text-muted"> · proxied</span>}
      </p>
    ))}
  </div>
);
